import { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { useKeikkaData } from "./KeikkaDataContext";
import { useStepLogData } from "./StepLogContext";
import { useToimitusData } from "./ToimitusContext";
import { useKeikkaLaskuData } from "./KeikkaLaskuContext";

const StatusContext = createContext();

export const StatusProvider = ({ children }) => {
  const {
    isLoadedPercent: keikkaDataLoadedPercent,
    isKeikkaDataLoaded,
    resetLoadingState: resetLoadingStateKeikkaData,
    reloadKeikkaData,
  } = useKeikkaData();
  const {
    isLoadedPercent: stepLogLoadedPercent,
    isStepLogLoaded,
    resetLoadingState: resetLoadingStateStepLog,
    reloadStepLog,
  } = useStepLogData();
  const {
    isLoadedPercent: toimitusLoadedPercent,
    toimitusStatus,
    resetLoadingState: resetLoadingStateToimitus,
    reloadToimitus,
  } = useToimitusData();
  const {
    isLoadedPercent: keikkaLaskuLoadedPercent,
    isKeikkaLaskuLoaded,
    resetLoadingState: resetLoadingStateKeikkaLasku,
    reloadKeikkaLasku,
  } = useKeikkaLaskuData();
  const isToimitusLoaded = toimitusStatus?.isLoaded;

  const reloadAll = async () => {
    resetLoadingStateKeikkaData();
    resetLoadingStateStepLog();
    resetLoadingStateToimitus();
    resetLoadingStateKeikkaLasku();
    await reloadKeikkaData();
    await reloadStepLog();
    await reloadToimitus();
    await reloadKeikkaLasku();
  };

  const _keikkaDataP = keikkaDataLoadedPercent.percent * keikkaDataLoadedPercent.count;
  const _stepLogP = stepLogLoadedPercent.percent * stepLogLoadedPercent.count;
  const _toimitusP = toimitusLoadedPercent.percent * toimitusLoadedPercent.count;
  const _keikkaLaskuP = keikkaLaskuLoadedPercent.percent * keikkaLaskuLoadedPercent.count;

  const _totalP =
    keikkaDataLoadedPercent.count +
    stepLogLoadedPercent.count +
    toimitusLoadedPercent.count +
    keikkaLaskuLoadedPercent.count;
  const isLoadedPercent = Math.round(
    (_keikkaDataP + _stepLogP + _toimitusP + _keikkaLaskuP) / _totalP
  );

  const isLoaded =
    isLoadedPercent > 90 ||
    (isKeikkaDataLoaded.finalize && isStepLogLoaded && isToimitusLoaded && isKeikkaLaskuLoaded);
  const isLoading = isLoadedPercent < 100;

  return (
    <StatusContext.Provider value={{ isLoadedPercent, isLoaded, isLoading, reloadAll }}>
      {children}
    </StatusContext.Provider>
  );
};

export const useStatusData = () => useContext(StatusContext);

StatusProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
